// extracted by mini-css-extract-plugin
export default {"container":"UserList_container__rNeHs","scroll":"UserList_scroll__SuDN-","list":"UserList_list__ofxtQ"};